import React, { useState } from 'react';
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Container,
  Grid,
  Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  registerUserEmail
} from '../../redux'
import { GoogleLogin } from 'react-google-login';
import { GOOGLE, API } from '../../config'
import swal from 'sweetalert'
import IconGoogle from '../../assets/img/icon-google.png'
import Axios from 'axios';
import * as SecureLs from 'secure-ls'

const ls = new SecureLs();


const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('xs')]: {
      paddingTop: '70px',
      height: 700
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: '70px',
      height: 750
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: '100px',
      height: 700
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: '120px',
      height: 700
    },
    [theme.breakpoints.up('xl')]: {
      paddingTop: '150px',
      height: 900
    },
  },
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  facebookclass: {
    width: '100%',
    height: '45px',
    backgroundColor: '#4267B2',
    color: '#fff',
    border: 'none',
    fontSize: '14px'
  },
  submitBtn: {
    borderRadius: '20px',
    backgroundColor: '#9e69d2',
    "&:hover": {
      backgroundColor: "#574bb3 !important",
    },
    paddingTop: '10px',
    paddingBottom: '10px',
    marginTop: '20px',
    marginBottom: '20px'
  },
  btnText: {
    textTransform: 'capitalize',
    fontSize: '15px',
    paddingLeft: '10px',
    paddingRight: '10px',
    fontWeight: 'bold',
    color: '#fbfbfb'
  },
  BtnGoogle: {
    backgroundColor: 'whitesmoke',
    "&:hover": {
      backgroundColor: "#dedede !important",
    },
  },
  btnText: {
    textTransform: 'capitalize',
    fontSize: '15px',
    paddingLeft: '10px',
    paddingRight: '10px',
    fontWeight: 'bold',
    color: '#fbfbfb'
  },
}));

const RegisterComponent = () => {
  const classes = useStyles();
  const [closeGoogle, setcloseGoogle] = useState(false);

  const responreg = useSelector(state => state.register)
  const dispatch = useDispatch()

  const [signupEmail, setSignupEmail] = useState({
    name: '',
    email: '',
    password: '',
    retype_password: ''
  })


  const handleChangeSignup = name => event => {
    setSignupEmail({
      ...signupEmail,
      [name]: event.target.value
    })
  }

  const onClickSubmit = (e) => {
    e.preventDefault()
    dispatch(registerUserEmail(signupEmail))
  }

  const showLoading = () => (
    responreg.loading && (
      <Box textAlign='center' pb={2} >
        <CircularProgress />
      </Box>
    )
  )


  const responseGoogle = (response) => {
    setTimeout(async () => {
      let id_token = response.tokenId
      let formdata = new FormData();

      formdata.append("id_token", id_token);
      const login = Axios.post(`${API}/login/google`, formdata)
        .then((res) => {
          if (res.data.data) {
            ls.set('@_tknid', { data: res.data.data.auth.token })
            ls.set('@_rtknid', { data: res.data.data.auth.refreshToken })
            localStorage.setItem('name', res.data.data.name)
            localStorage.setItem('id', res.data.data.id)
            swal("Success", "Now Redirecting..", "success");
            window.location.href = "/";
          }

        }).catch((res) => {
          swal("Error", `${res.data.error}`, "error");
        })
      return login;
    }, 1000);
  }
  const responseFailure = (e) => {
    setcloseGoogle(true)
  }


  return (
    <>

      <Container component="main" maxWidth="xs" className={classes.root}>
        <CssBaseline />
        <div className={classes.paper}>

          <Box pb={2} id='fontStyle' fontSize={35} fontWeight='bold' color='#9e69d2' >Daftar Akun</Box>

          <form className={classes.form} onSubmit={onClickSubmit} >
            {showLoading()}
            <Grid container spacing={1}>

              <Grid item xs={12} sm={12}>
                <TextField
                  size="small"
                  type='text'
                  onChange={handleChangeSignup('name')}
                  variant="outlined"
                  required
                  fullWidth
                  id="name"
                  label="Nama Lengkap"
                  autoFocus

                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  size="small"
                  variant="outlined"
                  required
                  id="email"
                  fullWidth
                  onChange={handleChangeSignup('email')}
                  label="Email"
                  type="email"

                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  variant="outlined"
                  required
                  fullWidth
                  onChange={handleChangeSignup('password')}
                  label="Password"
                  type="password"
                  id="password"

                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  variant="outlined"
                  required
                  fullWidth
                  onChange={handleChangeSignup('retype_password')}
                  label="Konfirmasi Password"
                  type="password"
                  id="repassword"

                />
              </Grid>

            </Grid>

            <Button
              type='submit'
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submitBtn}
            >
              <Box id='fontStyle' className={classes.btnText} >Daftar</Box>
            </Button>

            <Box mb={2} textAlign="center" style={{ width: "100%" }}>
              <GoogleLogin
                clientId={GOOGLE}
                render={renderProps => (
                  <Box textAlign="center">
                    <Button className={classes.BtnGoogle} fullWidth onClick={renderProps.onClick} disabled={renderProps.disabled} >
                      <Grid container alignContent="center" spacing={2} alignItems="center">
                        <Grid item xl={4} lg={4} md={4} sm={4} xs={3} >
                          <Box py={1} textAlign="right">
                            <img src={IconGoogle} alt="icon_google" width="25px" />
                          </Box> {' '}
                        </Grid>
                        <Grid item xl={8} lg={8} md={8} sm={8} xs={9} >
                          <Box py={1} textAlign="left" style={{ textTransform: "capitalize" }}>Daftar dengan Google</Box>
                        </Grid>
                      </Grid>
                    </Button>
                  </Box>
                )}
                buttonText="Daftar dengan Google"
                onSuccess={responseGoogle}
                onFailure={responseFailure}
                cookiePolicy={'single_host_origin'}
                isSignedIn={true}
              />
            </Box>

            <Grid container justify="flex-start">
              <Grid item>
                Sudah punya akun? {' '}
                <Link href="/login" variant="body2" style={{ color: '#9e69d2' }}>
                  Login sekarang
              </Link>
              </Grid>
            </Grid>
          </form>
        </div>

      </Container>

    </>
  );
}

export default RegisterComponent;